import { Toaster, ToasterProps } from 'sonner';

export const NoddiToaster = ({ ...props }: ToasterProps) => {
  return (
    <Toaster
      richColors
      visibleToasts={10}
      duration={3000}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--info-bg': 'var(--popover)',
          '--info-text': 'var(--primary)',
          '--info-border': 'var(--primary)'
        } as React.CSSProperties
      }
      {...props}
    />
  );
};
